import { useEffect, useRef, useState } from "react";
import { DropdownItem } from "react-bootstrap";
import { withNamespaces } from "react-i18next";
import { Dropdown, DropdownMenu, DropdownToggle, Label } from "reactstrap";
const options = [
    { 
        label: "Database Risks First", 
        value: "bafa_first", 
        icon: "ri-newspaper-line",
        options: {
            sortField: "is_bafa",
            sortOrder: "DESC"
        }
    },
    { 
        label: "Latest News First", 
        value: "news_first", 
        icon: "ri-file-text-line",
        options: {
            sortField: "is_news",
            sortOrder: "DESC"
        }
    },
    { 
        label: "Published Date (Newest First)", 
        value: "date_desc", 
        icon: "ri-calendar-line",
        options: {
            sortField: "publishedDate",
            sortOrder: "DESC"
        }
    },
    { 
        label: "Published Date (Oldest First)", 
        value: "date_asc", 
        icon: "ri-calendar-line",
        options: {
            sortField: "publishedDate",
            sortOrder: "ASC"
        }
    },
    { 
        label: "Unread First", 
        value: "unread_first", 
        icon: "ri-checkbox-blank-circle-line",
        options: {
            sortField: "read",
            sortOrder: "ASC"
        }
    },
    { 
        label: "Read First", 
        value: "read_first", 
        icon: "ri-checkbox-circle-fill",
        options: {
            sortField: "read",
            sortOrder: "DESC"
        }
    },
    { 
        label: "Flagged First", 
        value: "flagged_first", 
        icon: "ri-flag-line",
        options: {
            sortField: "flag",
            sortOrder: "DESC"
        }
    },
    { 
        label: "Unflagged First", 
        value: "unflagged_first", 
        icon: "ri-flag-2-line",
        options: {
            sortField: "flag",
            sortOrder: "ASC"
        }
    }
];

const SortingComponent = ({ 
    t,
    onChange 
}) => {
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const toggle = () => setDropdownOpen((prevState) => !prevState)

    const [selectedSort, setSelectedSort] = useState('bafa_first');

    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        
        if(selectedSort && onChange){
            const selectedOption = options.find((option) => option.value === selectedSort);
            onChange({
                event: 'sort',
                data: selectedOption.options
            })
            setDropdownOpen(false)
        }
    }, [ 
        selectedSort,
        onChange
    ])

    return (
        <div className="sorting-component me-2">
            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                <DropdownToggle 
                    caret 
                    color='secondary' 
                    outline
                    className="d-flex align-items-center justify-content-between" 
                    style={{
                        width: "220px"
                    }}
                >
                    <i className="ri-sort-desc me-2" />
                    <span
                        style={{
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden"
                        }}
                    >
                        {t('Sort by')}
                        {selectedSort && `: ${t(options.find((option) => option.value === selectedSort).label)}`}
                    </span>
                </DropdownToggle>

                <DropdownMenu 
                    className='dropdown-menu-end'
                >
                    {options.map((option) => (
                        <DropdownItem 
                            key={option.value}
                            onClick={() => {
                                setSelectedSort(option.value)
                            }}
                            className="d-flex justify-content-start align-items-center"
                        >
                            {selectedSort === option.value && <i className="ri-check-line me-1 font-size-20"></i>}
                            <i className={`${option.icon} me-2 font-size-20`}></i>
                            <Label style={{cursor: 'pointer'}} className="mb-0">
                                {t(option.label)}
                            </Label>
                            
                        </DropdownItem>
                    ))}
                </DropdownMenu>
            </Dropdown>
        </div>
    );
}

export default withNamespaces()(
    SortingComponent
);